import { Link } from "react-router-dom";
import { LineReveal } from "@/components/LineReveal";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="bg-[#050505] text-white min-h-screen flex flex-col justify-center px-6 md:px-12">
      <p className="text-[10px] tracking-[0.4em] uppercase text-white/40 mb-8">Checkout Cancelled</p>
      <LineReveal
        immediate
        lines={["The gallery", "stays open."]}
        className="font-serif text-6xl md:text-8xl leading-[1.0] tracking-tight mb-12"
      />
      <p className="text-sm text-white/60 max-w-md leading-relaxed mb-12">
        Nothing was charged. Your cart is exactly where you left it.
      </p>
      <Link
        to="/shop"
        data-testid="cancel-back-to-shop"
        className="inline-block w-fit border border-white/40 px-8 py-4 text-xs tracking-[0.3em] uppercase font-semibold hover:bg-white hover:text-black transition-colors duration-300"
      >
        Return to Shop
      </Link>
    </main>
  );
}
